
$(document).ready(function () {
    $("#second-slider").slick({
        dots: false,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        prevArrow: '<button class="slide-arrow prev-arrow"><img src="' + left_arrow + '"></button>',
        nextArrow: '<button class="slide-arrow next-arrow"><img src="' + righ_arrow + '"></button>',
        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 2,
                    dots: true,
                    arrows: false

                }
            },
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: true,
                    arrows: false
                }
            },
            {
                breakpoint: 599,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false
                }
            }
        ]
    });
    $(".fast_slider").slick({
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<button class="slide-arrow prev-arrow"><img src="' + left_arrow + '"></button>',
        nextArrow: '<button class="slide-arrow next-arrow"><img src="' + righ_arrow + '"></button>',
        responsive: [
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false
                }
            },
            {
                breakpoint: 599,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false
                }
            }
        ]
    });
    
    
    $(".hero-slider-items").slick({
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay:false,
        prevArrow: '<button class="slide-arrow prev-arrow"><img src="' + left_arrow + '"></button>',
        nextArrow: '<button class="slide-arrow next-arrow"><img src="' + righ_arrow + '"></button>',
        responsive: [
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false
                }
            },
            {
                breakpoint: 599,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false,
                    autoplaySpeed: 5000
                }
            }
        ]
    });

    

    $('.current__currency').on('click', function () {
        $('ul.header-currency').toggleClass('active');
    })

    document.querySelectorAll('.currency_selector').forEach(function (element) {
        element.addEventListener('change', currencyFormSubmit);
    });

    // header currency 
    $('.currency_btn').on('click', function () {
        $val = $(this).data('value');
        var parentForm = $(this).closest("form");
        $('.country_code').val($val);
        parentForm.submit();
    });

    $('.header__item__li__a').on('click', function () {
        $('.sidebar-menus').removeClass('active');
    });

    
});

$(window).scroll(function(){
    if ($(window).scrollTop()) {
        $('body').addClass('sticky-header');
        
    }
    else {
        $('body').removeClass('sticky-header');
    }
});

if(window.outerWidth < 500) {
    $(".carousel-product").slick({
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows:false,
    })
} 


// $(function(){
//     var lastScrollTop = 0, delta = 301;
//     $(window).scroll(function(event){
//        var st = $(this).scrollTop();
       
//        if(Math.abs(lastScrollTop - st) <= delta)
//             return;
//             if ((st > lastScrollTop) && (lastScrollTop>0)) {
//             // downscroll code
//                 $("header").css("top","-80px");
//             } else {
//                 // upscroll code
//                 $("header").css("top","0px");
//             }
//        lastScrollTop = st;
//     });
// });

$('.product-tab-title').on('click', function () {
    var id = $(this).data('id');
    $(this).addClass('active').siblings().removeClass('active');
    $('#tab_'+id).fadeIn('slow').siblings().fadeOut();
})

$('.faq-title').on('click', function () {
    var id = $(this).data('id');
    $(this).parent().toggleClass('active');
    $('#tab_'+id).slideToggle('slow');
})

$('.language__button').on('click', function () {
    $(this).toggleClass('active');
    $('#language_list').toggleClass('active');
})

$('.product_variant').on('click', function () {
    $(this).parent().parent().next().text($(this).data('price'));
    $(this).parent().parent().parent().find('.slick-current img').attr('src', $(this).data('img'));
})

$('.disclosure__item').on('click', function () {
    var lang = $(this).data('lang');
    $('#language_code').val(lang);
    $('#localization_form').submit();
})
$('.jdgm-preview-badge').on('click', function () {
    $('#review-title').addClass('active').siblings().removeClass('active');
    $('#tab_2').fadeIn('slow').siblings().fadeOut();

    $('html, body').animate({
        scrollTop: $("#tab_2").offset().top
    }, 2000);
})
$(document).ready(function(){
    var modal = document.getElementById("language_list");
    window.onclick = function(event) {
        modal.classList.remove = "active";
    }
});

$(".product-card-images").slick({
    dots: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    prevArrow: '<button class="slide-arrow left-arrow"><img src="'+ left_icon +'"></button>',
    nextArrow: '<button class="slide-arrow right-arrow"><img src="'+ right_icon +'"></button>', 
});
$(".mobile-media").slick({
    dots: true,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows:false
});

if(window.outerWidth < 767) {
    $(".other-header").parent('div').css("margin-bottom", "59px");
}else {
    $(".other-header").parent('div').css("margin-bottom", "90px");
}